import { FC } from 'react';
import { useRecoilState } from 'recoil';
import myInfoState from '../../atoms/myinfo';
import roomDetailState, { ProjectStatus } from '../../atoms/roomDetail';
import emitDestroyRoom from '../../connector/emits/destroyRoom';
import './RoomHeader.scoped.scss';
import { openConfirm } from '../../atoms/common';

interface RoomHeaderProps {
  ownerNickname: string;
  participants: number;
  thumbnailUrl: string;
  roomName: string;
}

const RoomHeader: FC<RoomHeaderProps> = ({
  ownerNickname,
  participants,
  thumbnailUrl,
  roomName
}) => {
  const [myInfo] = useRecoilState(myInfoState);
  const [roomDetail] = useRecoilState(roomDetailState);

  const leaveRoom = () => {
    window.location.href = '/chatting-app/waiting-room';
  };

  const destroyRoom = () => {
    if (roomDetail.projectStatus === ProjectStatus.PLAY) {
      openConfirm('진행중인 프리미엄를 그만두고, 방을 정말 삭제하시겠습니까?<br/>참가비는 회원들에게 반환됩니다.', () => emitDestroyRoom(roomDetail.id));
    } else {
      openConfirm('정말 방을 삭제하시겠습니까?', () => emitDestroyRoom(roomDetail.id));
    }
  }

  return (
    <div className="room-header">
      <div className="room-header__thumbnail">
        <img src={thumbnailUrl} alt="" />
      </div>
      <div>
        <div className="room-header__title">
          {/*          <div>
            <b>전체: 10승 0패 / 10연승</b>
          </div>
          <div>
            <b>파워볼: 5승 0패</b>
          </div>
          <div>
            <b>숫자합: 5승 0패</b>
          </div>*/}
          <div>{roomName}</div>
        </div>
        <div className="room-header__information">
          <div>
            <div className="room-header__owner">
              👑방장 <b>{ownerNickname}</b>
            </div>
            {/* <div className="room-header__time">52분전</div> */}
            <div className="room-header__participants">
              🤦‍♂️접속자 <b>{participants}</b>명
            </div>
            <div className="room-header__participants">
              👍좋아요 <b>{roomDetail.recommenders.length}</b>명
            </div>
            <div className="room-header__participants">
              🪙선물받은보석 <b>{roomDetail.giftedBullets.toLocaleString()}</b>개
            </div>            
            {/* <div className="room-header__participants" style={{ borderRight: 'none' }}>
              ✍️<b>{roomDetail.record.win}</b>승 <b>{roomDetail.record.defeat}</b>패
            </div> */}
            {/* <div className="room-header__participants">
              누적 보석수 <b>{'1,250'}</b>
            </div> */}
          </div>
          <div className="room-header__leave-room">
            <button onClick={leaveRoom}>채팅방 나가기</button>
          </div>
          {myInfo.id === roomDetail.owner ? (
            <div className="room-header__leave-room">
              <button onClick={destroyRoom}>채팅방 삭제</button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default RoomHeader;
